import React, { useRef, useMemo, memo } from "react";
import {
  InputField,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  TextField,
  Button,
  Avatar,
} from "@mui/material";
import { blue } from "@mui/material/colors";

import { createPlayList } from "./../../store/actions/playList";
import { CreateSharp, PersonIcon } from "@mui/icons-material";

function ListOfPlaylists({ playLists, addSong, createNewPlayList }) {
  const inputField = useRef(null);
  const handleListItemClick = (value) => {
    addSong(value);
  };

  return (
    <List
      sx={{
        pt: 2,
      }}>
      {Object.keys(playLists).map((playList) => (
        <ListItem
          button
          onClick={() => handleListItemClick(playList)}
          key={playList}>
          <ListItemAvatar>
            <Avatar sx={{ bgcolor: blue[50], color: blue[600] }}></Avatar>
          </ListItemAvatar>
          <ListItemText primary={playList} />
        </ListItem>
      ))}

      <ListItem autoFocus>
        <ListItemAvatar>
          <Avatar>
            <CreateSharp />
          </Avatar>
        </ListItemAvatar>
        <TextField inputRef={inputField} />
        <Button
          onClick={() =>
            createNewPlayList(createPlayList(inputField.current.value))
          }>
          Create
        </Button>
      </ListItem>
    </List>
  );
}
export default memo(ListOfPlaylists, function (prev, next) {
  const newPlaylists = Object.keys(next.playLists);
  const oldPlaylists = Object.keys(prev.playLists);
  if (newPlaylists.length === oldPlaylists.length) {
    let sameProps = true;
    oldPlaylists.forEach((key, index) => {
      if (key !== newPlaylists[index]) {
        sameProps = false;
      }
    });
    return sameProps;
  } else {
    return false;
  }
});
